import { Button, Col, Form, InputNumber, message, Modal, Typography } from 'antd'
import { PackageApi } from '../../../../api/Purchase/Package'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import _ from 'lodash'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import React, { useState } from 'react'

function ReadyToCollect (props) {
  const { order, line } = props
  console.log({ order, line })
  const { visible, onShow, onCancel } = useModalShow()
  const [submitting, setSubmitting] = useState(false)

  const remainingUnits = _.get(line, 'unit', 0) - _.get(line, 'ready', 0)
  const [units, setUnits] = useState(remainingUnits)
  const [unitPerPackage, setUnitPerPackage] = useState(remainingUnits)

  async function submit (e) {
    setSubmitting(true)
    try {
      const data = await PackageApi.create({
        purchases: order._id,
        purchasesLines: line._id,
        readyToCollect: pkg * unitPerPackage,
        unitsPerPackages: unitPerPackage,
      })
      onCancel()
      message.success('Success')
      setSubmitting(false)
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      setSubmitting(false)
    }
  }

  const pkgRemaining = units % unitPerPackage
  const pkg = (units - pkgRemaining) / unitPerPackage
  // const [Error, setError] = useState(false)
  //
  // React.useEffect(() => {
  //   setError(false)
  //
  //   if (unitPerPackage > units) {
  //     setError("Units Per Packages Can't Be Greater Then Units To Collect")
  //   }
  //
  //   console.log(pkg, pkg * unitPerPackage)
  //   if (pkg * unitPerPackage > remainingUnits) {
  //     setError("Total Units Can't Be Greater Then Remaining Units")
  //   }
  // }, [unitPerPackage, units])

  return (
    <>
      <Modal visible={visible} title={'Ready To Collect'} onCancel={onCancel} onOk={submit} destroyOnClose={true}>
        <Form>
          <Col>
            {/*<p>*/}
            {/*  {unitPerPackage} : {units}*/}
            {/*</p>*/}
            {/*<p>remain : {pkgRemaining}</p>*/}
            {/*<p>pkgs : {pkg}</p>*/}
            {/*<p>Total units per packages : {pkg * unitPerPackage}</p>*/}

            <Typography.Title level={4}>Remaining Units {remainingUnits}</Typography.Title>
            <Form.Item {...defaultFormItemLayout} label="Units to Collect">
              <InputNumber
                onChange={(e) => setUnits(e)}
                value={units}
                min={1}
                max={remainingUnits}
                style={{ width: '100%' }}
              />
            </Form.Item>

            <Form.Item {...defaultFormItemLayout} label="Units Per Packages">
              <InputNumber
                onChange={(e) => setUnitPerPackage(e)}
                max={units}
                min={1}
                value={unitPerPackage}
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Typography.Title level={4}>
              Packages Created {pkg} with total of {pkg * unitPerPackage}
            </Typography.Title>
          </Col>
        </Form>
      </Modal>
      <Button onClick={onShow} loading={submitting} disabled={!['Approved', 'Delivered'].includes(_.get(order, 'status'))}>
        Ready To Collect
      </Button>
    </>
  )
}

export default ReadyToCollect
